<template>
  <div-box :src="require('../../assets/img/zichan_bg@2x.png')">
    <wallet-head show_type="4" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false" :url="[
      '/api/v1/user/subgift',
      '/api/v1/user/exchange',
      '/api/v1/user/withdraw',
      '/api/v1/user/recharge'
    ][this.active]" :data="{}">
      <div-padding padding="4vw">
        <div-card bg="rgba(35, 35, 35,1)">
          <div-flex center>
            <div-width @click.native="router('USDT')">
              <div-text color='#fff' align="center" size='6vw'>{{ info.usdt || 0 }}</div-text>
              <div-text color='#999' align="center" size='4vw' center>USDT</div-text>
            </div-width>
          </div-flex>
          <div style="width: 100%;height: 10px;"></div>
          <div-flex br>
            <div-width @click.native="router('ACT')">
              <div-text color='#fff' align="center" size='6vw'>{{ info.act || 0 }}</div-text>
              <div-text color='#999' align="center" size='4vw' center>ACT</div-text>
            </div-width>
            <div-width @click.native="router('KAPAI')">
              <div-text color='#fff' align="center" size='6vw'>{{ info.card || 0 }}</div-text>
              <div-text color='#999' align="center" size='4vw' center>{{ $t('卡牌') }}</div-text>
            </div-width>
          </div-flex>
          <div style="width: 100%;height: 10px;"></div>
          <!-- <div-flex br>
            <div-width @click.native="router('ACTS')">
              <div-text color='#fff' align="center" size='6vw'>{{ info.acts || 0 }}</div-text>
              <div-text color='#999' align="center" size='4vw' center>ACTs</div-text>
            </div-width>
            <div-width @click.native="router('ACTSf')">
              <div-text color='#fff' align="center" size='6vw'>{{ info.frozen_acts || 0 }}</div-text>
              <div-text color='#999' align="center" size='4vw' center>{{ $t('冻结') }}ACTs</div-text>
            </div-width>
          </div-flex> -->
        </div-card>
        <div-card radius='2vw' padding='4vw' br="#0000000">
          <div-flex br>
            <div @click="router('huzhuan')">
              <div-flex center>
                <div-img width='13vw' height='13vw'>
                  <img src='../../assets/img/qb1.png' />
                </div-img>
              </div-flex>
              <div-height height='2vw' />
              <div-text color='#fff' size='3.5vw' center>{{ $t('互转') }}</div-text>
            </div>
            <div @click="router('shandui')">
              <div-flex center>
                <div-img width='13vw' height='13vw'>
                  <img src='../../assets/img/qb2.png' />
                </div-img>
              </div-flex>
              <div-height height='2vw' />
              <div-text color='#fff' size='3.5vw' center>{{ $t('闪兑') }}</div-text>
            </div>

            <div @click="router('tixian')">
              <div-flex center>
                <div-img width='13vw' height='13vw'>
                  <img src='../../assets/img/qb3.png' />
                </div-img>
              </div-flex>
              <div-height height='2vw' />
              <div-text color='#fff' size='3.5vw' center>{{ $t('提现') }}</div-text>
            </div>
            <div @click="router('chongzhi')">
              <div-flex center>
                <div-img width='13vw' height='13vw'>
                  <img src='../../assets/img/qb4.png' />
                </div-img>
              </div-flex>
              <div-height height='2vw' />
              <div-text color='#fff' size='3.5vw' center>{{ $t('充值') }}</div-text>
            </div>
          </div-flex>
        </div-card>
        <div-width>
          <div-tab tab='stick'>
            <van-tabs @click="opt()" v-model='active' background="#0F0F0F" color='#CEB082'>
              <van-tab>
                <template #title>
                  <div-text size='4vw' :color='active == 0 ? `#fff` : `#999`'>{{ $t('互转记录') }}</div-text>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div-text size='4vw' :color='active == 1 ? `#fff` : `#999`'>{{ $t('闪兑记录') }}</div-text>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div-text size='4vw' :color='active == 2 ? `#fff` : `#999`'>{{ $t('提现记录') }}</div-text>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div-text size='4vw' :color='active == 3 ? `#fff` : `#999`'>{{ $t('充值记录') }}</div-text>
                </template>
              </van-tab>
            </van-tabs>
          </div-tab>
        </div-width>
        <div-height height='3vw' />
        <div-card bg='#242424' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-text color='#fff' size='4vw'>{{ [$t('互转'), ['', $t('USDT兑ACT'), $t('ACT兑USDT'), $t('ACT兑卡牌'),
              $t('USDT兑ACTs')][item.type], $t('提现'), $t('充值')][active] }}</div-text>
            <div-text color='#CEB082' size='4vw' v-if="active == 0">{{ item.is_me == 0 ? '+' : '-' }}{{ item.amount
            }}ACT</div-text>
            <div-text color='#CEB082' size='4vw' v-if="active == 1">+{{ item.amount }}{{ ['', 'ACT', 'USDT',
              $t('卡牌')][item.type] }}</div-text>
            <div-text color='#CEB082' size='4vw' v-if="active == 2">
              -{{ item.actual_amount }}{{ item.coin_type == 1 ? 'USDT' : item.coin_type == 2 ? 'ACT' : "-" }}
            </div-text>
            <div-text color='#CEB082' size='4vw' v-if="active == 3">+{{ item.amount }}USDT</div-text>
          </div-flex>
          <van-divider style="margin:3vw 0" />
          <div-text color='#999' size='3.5vw' v-if="active == 0 && item.is_me == 1">{{ $t('到账地址') }}：{{
            item.to_user_mobile
          }}</div-text>
          <div-text color='#999' size='3.5vw' v-if="active == 0 && item.is_me == 0">{{ $t('来源地址') }}：{{ item.user_mobile
          }}</div-text>
          <div-text color='#999' size='3.5vw' v-if="active == 1">{{ $t('消耗数量') }}：{{ item.actual_num }}</div-text>
          <div-text color='#999' size='3.5vw' v-if="active == 2">{{ $t('提现地址') }}：{{ item.address }}</div-text>
          <!-- <div-text color='#999' size='3.5vw' v-if="active==3">{{$t('充值地址')}}：{{item.tx_hash}}</div-text> -->
          <div-flex left v-if="item.is_me != 0 && active != 3">
            <div-text color='#999999' size='3.5vw'>{{ $t('手续费') }}：</div-text>
            <div-text color='#CEB082' size='3.5vw'>{{ item.fee }}</div-text>
          </div-flex>
          <div-text v-if="active == 1 || active == 0" color='#999' size='3.5vw'>{{ [$t('互转'), $t('闪兑'),
          $t('提现')][active] }}{{
              $t('时间') }}：{{ item.created_at }}</div-text>

          <div-flex v-if="active == 2">
            <div-text color='#999' size='3.5vw'>{{ [$t('互转'), $t('闪兑'), $t('提现')][active] }}{{ $t('时间') }}：{{
              item.created_at
            }}</div-text>
            <div-text color='#CEB082' size='3.5vw'>{{ [$t('待审核'), $t('通过'), $t('驳回'), $t('转账中')][item.status]
            }}</div-text>
          </div-flex>
          <div-flex v-if="active == 3">
            <div-text color='#999' size='3.5vw'>{{ $t('充值') }}{{ $t('时间') }}：{{ item.created_at }}</div-text>
            <div-text color='#CEB082' size='3.5vw'>{{ [$t('检测中'), $t('成功')][item.status] }}</div-text>
          </div-flex>
          <div-flex left v-if="item.status == 2">
            <div-text color='#999999' size='3.5vw'>{{ $t('驳回原因') }}：</div-text>
            <div-text color='#CEB082' size='3.5vw'>{{ item.remark }}</div-text>
          </div-flex>
        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      info: {},
      list: [],
      url: "",
    }
  },
  created() {
    this.up_down()
    this.get_info()
  },
  methods: {
    opt() {
      this.up_down()
    },
    get_info() {
      this.$get({
        url: "/api/v1/user/info",
        data: {},
        success: (res) => {
          this.info = res.data
        },
        tip: () => { },
      })
    },
  },
}
</script>
<style lang='less' scoped></style>